var _rect, _rect2, _rect3, _rect4, _rect5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWinnerDecorations(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 283,
    height: 43,
    viewBox: "0 0 283 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 136,
    width: 2,
    height: 32,
    fill: "#FCD559"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 197.462,
    y: 22.7898,
    width: 2,
    height: 9.34985,
    transform: "rotate(17.8702 197.462 22.7898)",
    fill: "#FCD559"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 9.48404,
    transform: "matrix(-0.951754 0.306862 0.306862 0.951754 74.9517 23)",
    fill: "#FCD559"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 281.058,
    y: 14.8835,
    width: 2,
    height: 36.851,
    transform: "rotate(45 281.058 14.8835)",
    fill: "#FCD559"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 35.9581,
    transform: "matrix(-0.707107 0.707107 0.707107 0.707107 2.22192 15.5149)",
    fill: "#FCD559"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWinnerDecorations);
export default __webpack_public_path__ + "static/media/winner_decorations.c90af1400766a41869edc414822a2878.svg";
export { ForwardRef as ReactComponent };